import { PermissionDescriptor, UserPermissions, hasUserPermission } from '@prodcard/core'
import { find } from 'lodash'

export type NavigationLinkBase = {
  order: number
  title: string
  icon?: string
  permissions?: PermissionDescriptor[]
}

export type NavigationLink = NavigationLinkBase & {
  url: string
}

export type NavigationLinkGroup = NavigationLinkBase & {
  children: NavigationItem[]
}

export type NavigationItem = NavigationLink | NavigationLinkGroup

export function isNavigationLinkGroup(navLink: NavigationItem): navLink is NavigationLinkGroup {
  return (navLink as NavigationLinkGroup).children !== undefined
}

export function prepareNavLinks(links: NavigationItem[], permissions: UserPermissions): NavigationItem[] {
  return links
    .map(l => (isNavigationLinkGroup(l) ? { ...l, children: prepareNavLinks(l.children, permissions) } : l))
    .filter(l =>
      isNavigationLinkGroup(l)
        ? l.children.length > 0
        : l.permissions && l.permissions.length > 0
        ? !!find(l.permissions, p => hasUserPermission(permissions, p))
        : true,
    )
    .sort((l1, l2) => l1.order - l2.order)
}
